import { faIcon } from "@utils/faIcon"

import { Chip, IconButton } from "@atoms"

import { Popover, Select } from "@molecules"

import useCardsView from "@organisms/ObjectsView/CardsView/CardsView.context"
import useObjectsView from "@organisms/ObjectsView/ObjectsView.context"
import ScheduleHorizonControl from "@organisms/ViewMenu/ScheduleHorizonControl/ScheduleHorizonControl"

import styles from "./CardsViewMenu.module.scss"

const ascIcon = faIcon({ name: "arrow-down-a-z", style: "regular" })
const descIcon = faIcon({ name: "arrow-up-z-a", style: "regular" })

export const CARDS_VIEW_MENU_COMPONENT_IDS = ["main"]

export default function CardsViewMenu() {
    const {
        attributes,
        sortOptions,
        displayedAttributes,
        toggleAttribute,
        activeSorting,
        activeSortOption,
        setSortField,
        setCurrentSortToAscending,
        setCurrentSortToDescending,
    } = useCardsView()
    const { isScheduleHorizonAvailable } = useObjectsView()

    const isDescending = !!activeSorting?.desc
    const directionIcon = isDescending ? descIcon : ascIcon
    const directionLabel = isDescending ? "Sort ascending" : "Sort descending"
    const toggleDirection = isDescending ? setCurrentSortToAscending : setCurrentSortToDescending

    return (
        <Popover.View componentId="main">
            <Popover.Body>
                {isScheduleHorizonAvailable && (
                    <div className={styles.scheduleHorizonSection}>
                        <div className={styles.sectionTitle}>Schedule horizon</div>
                        <ScheduleHorizonControl isVisible={true} />
                    </div>
                )}
                <div className={styles.sortBySection}>
                    <div className={styles.sectionTitle}>Sort by</div>
                    <div className={styles.sortByRow}>
                        <Select.Root>
                            <Select.Input
                                isControlled={false}
                                placeholder="Select field"
                                className={styles.columnSelect}
                                selectedItem={
                                    activeSortOption && { value: activeSortOption.name, label: activeSortOption.label }
                                }
                                size="sm"
                            />
                            <Select.Viewport>
                                <Select.List title="Select field" className={styles.columnSelect}>
                                    <Select.ListSearch />
                                    <Select.ListGroup>
                                        {sortOptions.map((sortOption) => (
                                            <Select.ListItem
                                                variant="default"
                                                key={sortOption.name}
                                                item={{ value: sortOption.name, label: sortOption.label }}
                                                onSelect={() => setSortField(sortOption.name)}
                                                isSelected={activeSorting?.id === sortOption.name}
                                            />
                                        ))}
                                    </Select.ListGroup>
                                </Select.List>
                            </Select.Viewport>
                        </Select.Root>
                        <IconButton
                            variant="subtle"
                            size="lg"
                            icon={directionIcon}
                            onClick={toggleDirection}
                            isDisabled={!activeSorting}
                            noDebounce={true}
                            aria-label={directionLabel}
                        />
                    </div>
                </div>
                <div className={styles.attributesSection}>
                    <div className={styles.sectionTitle}>Attributes</div>
                    <div className={styles.attributesRow}>
                        {attributes.map((attribute) => (
                            <Chip
                                key={attribute.name}
                                size="sm"
                                isSelected={displayedAttributes.includes(attribute.name)}
                                onClick={() => toggleAttribute(attribute.name)}
                                noDebounce={true}
                            >
                                {attribute.label}
                            </Chip>
                        ))}
                    </div>
                </div>
            </Popover.Body>
        </Popover.View>
    )
}
